import { type FC, useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { DialogConfirmation } from 'app/KinerjaKSPage/components/CardDataConfirmation/DialogConfirmation'
import { DetailLoading } from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail/DetailLoading'
import { useData } from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/hooks'
import Detail from 'app/KinerjaKSPage/components/CardDataConfirmation/Detail'

import type { School } from 'types/kinerja-ks'

type Props = {
  npsn: School['npsn']
}

export const CardDataConfirmation: FC<Props> = ({ npsn }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { isLoading, isError, atasan, listItems, block } = useData({
    npsn,
  })

  if (isError || !block) return null

  if (isLoading)
    return (
      <Detail.Root>
        <DetailLoading />
      </Detail.Root>
    )

  return (
    <>
      {!!block && (
        <>
          <Detail.Root className={block?.className}>
            <Detail.Content
              icon={block?.icon}
              title={block?.title}
              description={block?.description}
            >
              <div className="space-y-1">
                {listItems?.map(({ label, value, status, callback }, index) => {
                  const valueBlock = (
                    <>
                      <Text color="subdued">:</Text>
                      <Detail.ContentListValue
                        endsWithDot
                        status={status}
                        value={value}
                        color="subdued"
                      />
                    </>
                  ) as React.ReactNode
                  return (
                    <Detail.ContentList key={index} label={label}>
                      {/* If callback is set */}
                      {!!callback &&
                        callback({
                          value: (
                            <Detail.ContentListValue
                              status={status}
                              value={value}
                              color="subdued"
                            />
                          ),
                          colon: <Text color="subdued">:</Text>,
                          valueBlock,
                        })}

                      {/* If callback is not set */}
                      {!callback && valueBlock}
                    </Detail.ContentList>
                  )
                })}
              </div>
              {!!block?.button && (
                <div>
                  <Button {...block?.button} onClick={() => setIsOpen(true)} />
                </div>
              )}
            </Detail.Content>
          </Detail.Root>

          {/* To only be mounted if it's expected to be opened */}
          {isOpen && (
            <DialogConfirmation
              data={atasan}
              isOpen={isOpen}
              isReconfirm={block?.type === 'RECONFIRM'}
              onClose={() => setIsOpen(false)}
            />
          )}
        </>
      )}
    </>
  )
}
